import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Home from './components/Home';
import Projects from './components/Projects';
import ProjectDetail from './components/ProjectDetail';
import Services from './components/Services';
import Admin from './components/Admin';
import './App.css';

function App() {
  return (
    <Router>
      <div>
        <Navigation />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projeler" element={<Projects />} />
          <Route path="/proje/:id" element={<ProjectDetail />} />
          <Route path="/hizmetler" element={<Services />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        
        <footer className="footer">
          <div className="container">
            <p>&copy; 2024 <span className="accent-text">Selenay Oğuz</span> - Tüm hakları saklıdır.</p>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;
